// extracted by mini-css-extract-plugin
export var boxItems = "_1w-1";
export var boxItemsLg = "_1w-2";
export var button = "_1w-7";
export var buttonLg = "_1w-8";
export var filterGroupBox = "_1w-0";
export var icon = "_1w-3";
export var iconSecondary = "_1w-6";
export var iconWrapper = "_1w-4";
export var iconWrapperLg = "_1w-5";